module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.id == 0 ? 'Inserir 	Novo Email' : 'Editar Email'),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.emailItems
    }
  }), _vm._v(" "), (_vm.formData.usuario) ? _c('EdAlert', {
    attrs: {
      "title": "Última Atualização"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('b', [_vm._v("Usuário:")]), _vm._v(" " + _vm._s(_vm.formData.usuario.usuario)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Data:")]), _vm._v(" " + _vm._s(_vm.toDate(_vm.formData.updated_at)) + "\n          ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('EdAlert', {
    attrs: {
      "title": "Atenção",
      "description": "Aqui você pode cadastrar múltiplos emails para essa empresa especificando cada email por setores",
      "type": "warning"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Novo Email",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onSearch": _vm.getEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2126b9b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/meu-cadastro/email/index.vue
// module id = 1451
// module chunks = 45